const person = {
  displayField: 'name',
  name: 'Person',
  description: '',
  fields: [
    {
      id: 'img',
      name: 'Image',
      type: 'Link',
      localized: false,
      required: true,
      validations: [ { assetFileSize: { min: null, max: 102400 } } ],
      disabled: false,
      omitted: false,
      linkType: 'Asset'
    },
    {
      id: 'name',
      name: 'Name',
      type: 'Symbol',
      localized: false,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'description',
      name: 'Title',
      type: 'Symbol',
      localized: true,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'ctaText',
      name: 'Cta Text',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'ctaUrl',
      name: 'Cta Url',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: { id: 'person', version: 8, updatedAt: '2023-08-03T14:23:06.351Z' }
};
export default person;